import { Button, Flex, Text, Input, Menu, MenuButton, MenuItem, MenuList, useColorMode, useColorModeValue, InputGroup, InputLeftElement, FormLabel, Box, Center, Square } from '@chakra-ui/react';
import React, { useEffect, useRef, useState, useMemo } from 'react'
import { IoCheckmark, IoChevronDown, IoCloudUpload, IoLocation, IoTrash, IoWarning } from 'react-icons/io5';
import { categories } from '../data';
import Spinner from './Spinner';

//
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { firebaseApp } from "../firebase-config";
import AlertMsg from './AlertMsg';
import { Editor } from '@tinymce/tinymce-react';
import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { fetchUser } from '../utils/fetchUser';
import JoditEditor from 'jodit-react';

const config = {
  readonly: false, // all options from https://xdsoft.net/jodit/doc/
  height: '250px',
  // maxWidth: '1500px',
  // minWidth: '270px',
  enableDragAndDropFileToEditor: true,
  buttons: [
    'source',
    '|',
    'bold',
    'italic',
    'underline',
    '|',
    'ul',
    'ol',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'image',
    'table',
    'link',
    '|',
    'left',
    'center',
    'right',
    'justify',
    '|',
    'undo',
    'redo',
    '|',
    'hr',
    'eraser',
    'fullsize',
  ],
  uploader: { insertImageAsBase64URI: true },
  removeButtons: ['brush', 'file'],
  showXPathInStatusbar: false,
  showCharsCounter: false,
  showWordsCounter: false,
  toolbarAdaptive: true,
  toolbarSticky: true,
  style: {
    background: '#1a202c',
    color: 'rgba(255,255,255,0.5)',
  },
};

const Create = () => {

  const { colorMode } = useColorMode();
  const bg = useColorModeValue('gray.600', 'gray.300');
  const textColor = useColorModeValue('gray.900', 'gray.50')

  const editorRef = useRef(null);


  const [title, setTitle] = useState('')
  const [category, setCategory] = useState('Category')
  const [location, setLocation] = useState('')
  const [videoAsset, setVideoAsset] = useState(null)
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(1)
  const [alert, setAlert] = useState(false)
  const [alertStatus, setAlertStatus] = useState('')
  const [alertMsg, setAlertMsg] = useState('')
  const [alertIcon, setAlertIcon] = useState(null)
  const [description, setDescription] = useState('')

  const [userInfo] = fetchUser();
  const navigate = useNavigate();

  const storage = getStorage(firebaseApp);
  const fireStoreDb = getFirestore(firebaseApp)


  const uploadImage = (e) => {
    setLoading(true)
    const videoFile = e.target.files[0]

    const storageRef = ref(storage, `Videos/${Date.now()}-${videoFile.name}`)

    const uploadTask = uploadBytesResumable(storageRef, videoFile)

    uploadTask.on('state_changed', (snapshot) => {
      const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      setProgress(uploadProgress)
    }, (error) => {
      console.log(error)
    }, () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadurl) => {
        setVideoAsset(downloadurl)
        setLoading(false)
        setAlert(true)
        setAlertStatus('success')
        setAlertMsg('video uploaded')
        setAlertIcon(<IoCheckmark fontSize={25} />)
        setTimeout(() => {
          setAlert(false)
        }, 4000)
      })
    })
  }

  const deleteImage = () => {
    const deleteRef = ref(storage, videoAsset)
    deleteObject(deleteRef).then(() => {
      setVideoAsset(null)
      setAlert(true)
      setAlertStatus('error')
      setAlertMsg('video removed')
      setAlertIcon(<IoWarning fontSize={25} />)
      setTimeout(() => {
        setAlert(false)
      }, 4000)
    }).catch((error) => {
      console.log(error);
    })
  }

  const getDescriptionValue = () => {
    if (editorRef.current) {
      console.log(editorRef.current.value);
      setDescription(editorRef.current.value);
    }
  }

  const uploadDetails = async () => {
    try {
      setLoading(true)
      if (!title && !category && !videoAsset) {
        setAlert(true)
        setAlertStatus('error')
        setAlertMsg('Required Fields are Missing')
        setAlertIcon(<IoWarning fontSize={25} />)
        setTimeout(() => {
          setAlert(false)
        }, 4000)
        setLoading(false)
      } else {
        const data = {
          id: `${Date.now()}`,
          title: title,
          userId: userInfo?.uid,
          category: category,
          location: location,
          videoUrl: videoAsset,
          description: description,
        }

        await setDoc(doc(fireStoreDb, 'videos', `${Date.now()}`), data)
        setLoading(false);
        navigate('/', { replace: true })
      }
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => { }, [title, location, description, category]);

  return <Flex
    justifyContent={'center'}
    alignItems='center'
    width={'100%'}
    minHeight='50vh'
    // pt={5}
    pb={20}
  >
    <Flex
      width={'100%'}
      height={{ base: '90vh', md: '80vh', lg: '100vh' }}
      border={'1px'}
      borderColor='gray.300'
      borderRadius={'md'}
      p={{ base: '2', lg: '4' }}
      flexDirection={'column'}
      alignItems='center'
      justifyContent={'center'}
      gap={2}
    >
      {alert && (
        <AlertMsg
          status={alertStatus}
          msg={alertMsg}
          icon={alertIcon}
        />
      )}
      <Input
        variant={'flushed'}
        placeholder='Title'
        focusBorderColor='gray.400'
        isRequired
        errorBorderColor='red'
        type={'text'}
        _placeholder={{ color: 'gray.500' }}
        fontSize={20}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <Flex
        justifyContent={'space-between'}
        width='full'
        alignItems={'center'}
        gap={8}
        my={4}
      >
        <Menu

        >
          <MenuButton
            width={'full'}
            colorScheme='blue'
            as={Button}
            rightIcon={<IoChevronDown fontSize={20} />}>
            {category}
          </MenuButton>
          <MenuList zIndex={101} width={'sm'} shadow='xl'>
            {categories && categories.map(data => (
              <MenuItem
                key={data.id}
                _hover={{ bg: 'blackAlpha.300' }}
                fontSize={20}
                px={4}
                onClick={() => setCategory(data.name)}
              >
                {data.iconSrc} {''} <Text fontSize={18} ml={4}>{data.name}</Text>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Flex>
      {/*file selection */}

      <Flex
        border={'1px'}
        borderColor='gray.500'
        height={'400px'}
        borderStyle='dashed'
        width='full'
        borderRadius={'md'}
        overflow='hidden'
        position={'relative'}
      >
        {!videoAsset ? (
          <FormLabel width='full'>
            <Flex
              direction={'column'}
              alignItems='center'
              justifyContent={'center'}
              height='full'
              width={'full'}
            >
              <Flex
                direction={'column'}
                alignItems='center'
                justifyContent={'center'}
                height='full'
                width={'full'}
                cursor='pointer'
              >
                {loading ? (<Spinner msg={'Uploading Your Video'} progress={progress} />) : (
                  <>
                    <IoCloudUpload
                      fontSize={30}
                      color={`${colorMode == 'dark' ? '#f1f1f1' : '#111'}`}
                    />
                    <Text
                      mt={5}
                      fontSize={{ base: '12px', md: '18px', lg: '20px' }}
                      color={textColor}
                    >
                      Click to Upload
                    </Text>
                  </>
                )}
              </Flex>
            </Flex>

            {!loading && (
              <input
                type={'file'}
                name='upload-image'
                onChange={uploadImage}
                style={{ width: 0, height: 0 }}
                accept="video/mp4,video/x-m4v,video/*"
              >
              </input>
            )}
          </FormLabel>
        ) : (
          <Flex
            width={'full'}
            height='full'
            alignItems={'center'}
            justifyContent={'center'}
            bg='black'
            position={'relative'}
          >
            <Flex
              justifyContent={'center'}
              alignItems={'center'}
              width={'40px'}
              height={'40px'}
              rounded='full'
              bg={'red'}
              top={5}
              right={5}
              position={'absolute'}
              cursor={'pointer'}
              zIndex={10}
              onClick={deleteImage}
            >
              <IoTrash fontSize={20} color='white' />
            </Flex>
            <video
              src={videoAsset}
              controls
              style={{ width: "100%", height: "100%" }}
            />
          </Flex>
        )}
      </Flex>

      <JoditEditor
        ref={editorRef}
        value={description}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onChange={getDescriptionValue}
      />

      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        cursor={'pointer'}
      >
        <Button
          isLoading={loading}
          loadingText="Uploading"
          colorScheme={"linkedin"}
          variant={`${loading ? 'outline' : 'solid'}`}
          width={{ base: '200px', md: 'md', lg: 'xl' }}
          _hover={{ shadow: 'lg' }}
          fontSize={20}
          onClick={() => uploadDetails()}
        >
          Upload
        </Button>
      </Flex>
    </Flex>
  </Flex>
}

export default Create
